export class AzureDiskRestoreDestination {
    'azureDisk';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "azureDisk",
            "baseName": "azureDisk",
            "type": "AzureDiskTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
